import { render } from "./ExitDeclarationCard.vue?vue&type=template&id=584b4c22"
import script from "./ExitDeclarationCard.vue?vue&type=script&lang=js"
export * from "./ExitDeclarationCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__